import { TipType } from '../../store/statistic';
import { Option } from '../../types';
import {
  DefaultFetchError,
  FetchCreate,
  FetchGetId,
  FetchSuccess,
  useFetchCreate,
  useFetchGetId,
} from '../fetch';

export interface SubCategoryTip {
  tipType: TipType;
  value: number;
  customValue: number;
}

export type SubCategoryTipCreateData = {
  tipType: TipType;
  value?: number;
  customValue?: number;
}

export const useSubCategoryTipCreate = (): FetchCreate<
  FetchSuccess,
  DefaultFetchError,
  SubCategoryTipCreateData
> => useFetchCreate(
  'sub-categories',
  { autoStart: false, startStateLoading: false },
);

export const useSubCategoryTip = (id?: string): FetchGetId<SubCategoryTip, DefaultFetchError, FetchSuccess> => (
  useFetchGetId(
    'sub-categories', // `${subCategoryId}/tips`
    id ? `${id}/tips` : '',
    { autoStart: !!id, startStateLoading: false, authorization: true },
  )
);

export interface SubCategoryTipStatisticsData {
  forGraph: {
    customerPercents: Option<number, string>[];
    customerValues: Option<number, string>[];
    workerPercents: Option<number, string>[];
    workerValues: Option<number, string>[];
  },
  customerAvgPercent: number;
  customerAvgValue: number;
  workerAvgPercent: number;
  workerAvgValue: number;
}

export const useSubCategoryTipStatistics = (id?: string): FetchGetId<
  SubCategoryTipStatisticsData, DefaultFetchError> => (
  useFetchGetId(
    'sub-categories', // `${subCategoryId}/tips-statistics`
    id ? `${id}/tips-statistics` : '',
    { autoStart: !!id, startStateLoading: false, authorization: false },
  )
);

export default {
  useSubCategoryTipCreate,
  useSubCategoryTip,
};
